import { gql } from 'graphql-request';

export const TARGET_PRODUCTS = gql`
  query GetSephoraProducts {
    collection(handle: "target") {
      handle
      products(first: 25) {
        edges {
          node {
            id
            title
            handle
            tags
            availableForSale
            variants(first: 5) {
              edges {
                node {
                  id
                  availableForSale
                }
              }
            }
            priceRange {
              maxVariantPrice {
                amount
              }
            }
            featuredImage {
              url
            }
          }
        }
      }
    }
  }
`;
